import { ICurrentPolicyFlow } from "@redux/slices/loadingSlice";

export const DEFAULT_CONFIG = {
  urlApi: "",
  brochureUrlSio:
    "https://www.aviva.com.sg/content/dam/asl-public/sg/documents/aviva-life/mysimpletermplan.pdf",
  brochureUrlDpi:
    "https://www.aviva.com.sg/content/dam/asl-public/sg/documents/aviva-life/Direct-Purchase-Insurance.pdf",
  avivaWebsiteUrl: "https://www.aviva.com.sg/en",
  avivaContactUsUrl: "https://www.aviva.com.sg/en/pdpa#contact-us",
  brochureUrlShieldStarter:
    "https://singlife.com/content/dam/public/sg/documents/medical-insurance/singlife-shield-starter-and-health-plus/brochure.pdf",
  brochureUrlCCP:
    "https://singlife.com/content/dam/public/sg/documents/medical-insurance/singlife-cancer-cover-plus-ii/singlife-cancer-cover-plus-ii-product-brochure.pdf",
  persistDataTimeout: 1200000,
  insuranceEstimatorUrl:
    "https://www.cpf.gov.sg/eSvc/Web/Schemes/InsuranceEstimator/InsuranceEstimator",
  budgetCalculatorUrl:
    "https://www.moneysense.gov.sg/financial-tools/budget-calculator",
  compareFirstUrl: "https://www.comparefirst.sg",
};

export enum PLANS_NAME {
  MLTC = "MLTC",
  SHIELD_STARTER = "SHIELD_STARTER",
  EVER_GREEN = "EVER_GREEN",
  CANCER_COVER_PLUS = "CANCER_COVER_PLUS",
  DEFAULT = "DEFAULT",
}

export const PLANS: Record<string, string> = {
  [PLANS_NAME.MLTC]: "mltc",
  [PLANS_NAME.SHIELD_STARTER]: "shieldstarter",
  [PLANS_NAME.EVER_GREEN]: "evergreen",
  [PLANS_NAME.CANCER_COVER_PLUS]: "ccp",
};

type planConfig = {
  [key: string]: ICurrentPolicyFlow;
};

export const PLANS_CONFIG: planConfig = {
  [PLANS_NAME.MLTC]: {
    policy: "MLTC",
    isRevampedLayout: true,
  },
  [PLANS_NAME.SHIELD_STARTER]: {
    policy: "SHIELD_STARTER",
    isRevampedLayout: true,
  },
  [PLANS_NAME.EVER_GREEN]: {
    policy: "EVER_GREEN",
    isRevampedLayout: true,
  },
  [PLANS_NAME.CANCER_COVER_PLUS]: {
    policy: "CANCER_COVER_PLUS",
    isRevampedLayout: true,
  },
  [PLANS_NAME.DEFAULT]: {
    policy: "",
    isRevampedLayout: false,
  },
};
export const HOME_URL = "https://singlife.com/";

export const UOB_CONTACT_URL =
  "https://forms.uob.com.sg/personal/wealth/contact-us.html?type=insurance&i_cid=pfs:sg:owned:int:pweb:micro:bu:inshome:lifeinsure:280221-evergreen:na:product";
export const UTM_CANCER_URL =
  "https://singlife.com/en/medical-insurance/singlife-cancer-cover-plus?utm_source=sss-direct-sales-portal&utm_campaign=xsell&utm_content=thank-you-page";
export const UTM_CARESHIELD_URL =
  "https://singlife.com/en/disability-insurance/careshield?utm_source=sss-direct-sales-portal&utm_campaign=xsell&utm_content=thank-you-page";

export const MAX_FILE_UPLOAD_COUNT = 5;
export const MAX_INPROGRESS_UPLOAD_COUNT = 2;
export const MAX_FILE_SIZE = 3000000; // 3MB
export const MAX_FILE_SIZE_MB = "3MB"; // 3MB
export const ACCEPTED_FILE_TYPES = "pdf, jpg, jpeg or png format."; // temporary removed doc and ppt formats
// export const ACCEPTED_FILE_TYPES = "pdf, doc, docx, ppt, pptx, jpg, jpeg or png format.";
export const MLTC_CAMPAIGN_CODES_LIST = ["LUB1", "MLO2"];
export const SHIELD_STARTER_CAMPAIGN_CODES_LIST = ["SHIELDSTARTER2"];
